import ZkTableColumn from '../table/src/table-column.jsx';

/* istanbul ignore next */
ZkTableColumn.install = function(Vue) {
  Vue.component(ZkTableColumn.name, ZkTableColumn);
};

export default ZkTableColumn;



// WEBPACK FOOTER //
// ./src/packages/table-column/index.js